import { cn } from '@/lib/utils';
import { lotusMorph } from '@/shared/assets';

export interface LotusLoaderProps {
  className?: string;
  size?: number;
}

export function LotusLoader({ className, size = 24 }: LotusLoaderProps) {
  return (
    <img
      src={lotusMorph}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      className={cn('animate-lotus-pulse', className)}
    />
  );
}
